import axios from "axios";
const baseURL ='https://intelligent-bohr.85-215-170-134.plesk.page/api/'


const source = axios.create({
    baseURL,

  });
  
  export default source